import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ContactInformationSection.Title',
    defaultMessage: 'Contact Information',
  },
  phoneLabel: {
    id: 'App.ContactInformationSection.PhoneLabel',
    defaultMessage: 'Phone',
  },
  phonePlaceholder: {
    id: 'App.ContactInformationSection.PhonePlaceholder',
    defaultMessage: 'Phone Number',
  },
  emailLabel: {
    id: 'App.ContactInformationSection.EmailLabel',
    defaultMessage: 'Email',
  },
  emailPlaceholder: {
    id: 'App.ContactInformationSection.EmailPlaceholder',
    defaultMessage: 'Email Address',
  },
  fieldTypeLabel: {
    id: 'App.ContactInformationSection.FieldTypeLabel',
    defaultMessage: 'Type',
  },
  addEmail: {
    id: 'App.ContactInformationSection.AddEmail',
    defaultMessage: 'Add Email',
  },
  addPhone: {
    id: 'App.ContactInformationSection.AddPhone',
    defaultMessage: 'Add Phone',
  },
  // Email Types
  emailTypePersonal: {
    id: 'App.ContactInformationSection.EmailTypePersonal',
    defaultMessage: 'Personal',
  },
  emailTypeWork: {
    id: 'App.ContactInformationSection.EmailTypeWork',
    defaultMessage: 'Work',
  },
  emailTypeOther: {
    id: 'App.ContactInformationSection.EmailTypeOther',
    defaultMessage: 'Other',
  },
  // Phone Types
  phoneTypeMobile: {
    id: 'App.ContactInformationSection.PhoneTypeMobile',
    defaultMessage: 'Mobile',
  },
  phoneTypeWork: {
    id: 'App.ContactInformationSection.PhoneTypeWork',
    defaultMessage: 'Work',
  },
  phoneTypeHome: {
    id: 'App.ContactInformationSection.PhoneTypeHome',
    defaultMessage: 'Home',
  },
  phoneTypeOther: {
    id: 'App.ContactInformationSection.PhoneTypeOther',
    defaultMessage: 'Other',
  },
  // Validation
  invalidEmail: {
    id: 'App.ContactInformationSection.InvalidEmail',
    defaultMessage: 'Please enter a valid email address',
  },
  invalidPhoneNumber: {
    id: 'App.ContactInformationSection.InvalidPhoneNumber',
    defaultMessage: 'Please enter a valid phone number',
  },
  duplicateEmail: {
    id: 'App.ContactInformationSection.DuplicateEmail',
    defaultMessage: 'This email address is already used',
  },
  duplicatePhoneNumber: {
    id: 'App.ContactInformationSection.DuplicatePhoneNumber',
    defaultMessage: 'This phone number is already used',
  },
});

export default messages;
